import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./SideBar.css";
import { appNavs } from "../../config";
import SideBarNav from "./SidebarNav";
import SidebarNavToggle from "./SidebarNavToggle";
import { Loader } from "@aws-amplify/ui-react";

const SideBar = (props) => {
  const [expand, setExpand] = useState(false);

  let location = useLocation();

  useEffect(() => {
    setExpand(false);
  }, [location]);

  return (
    <>
      <div className="btn-sidebar-nav">
        <SidebarNavToggle expand={expand} onChange={() => setExpand(!expand)} />
      </div>
      <div className={"sidebar " + (expand ? "visible" : "")}>
        <SideBarNav navs={appNavs.map(nav => {
          if(nav.roles === undefined || nav.roles.includes(props.role)){
            return nav;
          } else if (props.role === undefined || props.role === ''){
            return {eventKey: "loader", icon: <Loader/>, title: "", to: "/"};
          }
          return {};
        })} />
      </div>
    </>
  );
};

export default SideBar;
